export const BANK_FEED_ROUTE_TABS = {
  TRANSACTIONS: 'transactions',
  CREDIT_CARDS: 'credit-cards',
} as const;

export type BankFeedRouteTab = (typeof BANK_FEED_ROUTE_TABS)[keyof typeof BANK_FEED_ROUTE_TABS];

export const BANK_FEED_TAB_ACCOUNT_TYPES = {
  [BANK_FEED_ROUTE_TABS.TRANSACTIONS]: 'CHECKING',
  [BANK_FEED_ROUTE_TABS.CREDIT_CARDS]: 'CARD',
} as const;
